import type { IResponseListData } from 'shared/api'
import { type IResponsePagination } from 'entities/Integrations'

export type IReviewParams = {
  name: string
  image_url: string
  color: string
  title: string
  subtitle: string
  happy_subtitle: string
  unhappy_subtitle: string
  accounts: IReviewAccount[]
}

export type IResponseReview = {
  id: number
  uuid: string
  name: string
  organization_id: number
  owner_id: number
  short_url: string
  image_url: string
  color: string
  title: string
  subtitle: string
  happy_subtitle: string
  unhappy_subtitle: string
  accounts: IReviewAccount[]
  created_at: string
  updated_at: string
  all_statistics?: IResponseReviewStatistic
}

export type IReviewsListParams = {
  search?: string
  order?: 'asc' | 'desc'
  sortBy?: string
  per_page?: number
  page?: number
}

export type IResponseListReview = IResponseReview & {
  rating: number
  happy_count: number
  unhappy_count: number
  click_count: number
}

export type IResponseReviewsList = IResponseListData<IResponseListReview>

export type IReviewUploadImageParams = FormData

export type IResponseReviewUploadImage = {
  url: string
}

export type IReviewDeleteImageParams = {
  url: string
}

export type IResponseReviewDeleteImage = {
  deleted: boolean
}

export type IReviewAccount = {
  id?: number
  type: IReviewAccountType
  url_link: string
  button_name: string
  sort_order?: number
}

export type IResponseReviewStatistic = {
  click_count: number
  happy_count: number
  rating: number
  total_count: number
  unhappy_count: number
  links_total: number
  links: Partial<Record<IReviewAccountType, number>>
}

export type IReviewContactsFilter = 'total' | 'happy' | 'unhappy' | 'clicked' | IReviewAccountType

export type IReviewContactsParams = {
  filter: IReviewContactsFilter
  search?: string
  page?: number
  length?: number
  sortBy?: string
  order?: 'asc' | 'desc'
}

export type IReviewContact = {
  id: number
  comment: string | null
  created_at: string
  deleted_at: string | null
  formatted_number: string | null
  national_number: string | null
  number: string | null
  full_name: string | null
  first_name: string | null
  last_name: string | null
  photo_url: string | null
  rate: number
  archived_at: string | null
  color_index: number
  is_blocked: number
  is_opted_out: number
  short_url_clicks?: number
  short_url_last_clicked_at?: string | null
  last_clicked_at?: string | null
}

export type IResponseReviewContacts = IResponsePagination<IReviewContact[]>

export type IRequestReviewsAllParams = {
  query?: string
}

export type IRequestReview = {
  id: number
  name: string
  short_url: string
}

export type IResponseRequestReviewsAll = IRequestReview[]

export enum EnumReviewAccount {
  google = 'Google',
  facebook = 'Facebook',
  yelp = 'Yelp',
  bbb = 'BBB',
  angi = 'Angi',
  capterra = 'Capterra',
  g2 = 'G2',
  custom = 'Custom link',
}

export type IReviewAccountType = keyof typeof EnumReviewAccount
